import { HStack, Avatar, Menu, MenuList, Button, MenuButton, MenuGroup, MenuItem, MenuDivider, Text } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { HamburgerIcon } from '@chakra-ui/icons';
import { Link as RouterLink } from 'react-router-dom';
import { SessionContext } from '../../../contexts/SessionContext';
import { SessionReducerActionOptions } from '../../../reducers/SessionReducer';
import { useTranslation } from 'react-i18next';
import { AiOutlineUser } from 'react-icons/ai';
import { useDetectIsAdmin, useDetectIsLogged, useGetUserDetails } from '../../../helpers/getUser';
import { PropertyInfoReducerActionOptions } from '../../../reducers/PropertyInfoReducer';
import { PropertyInfoContextDto } from '../../../contexts/dtos/PropertyInfoContextDto';
import { PropertyInfoContext } from '../../../contexts/PropertyInfoContext';
import { useRouteHelper } from '../../../hooks/routesHelpers';

export const AccountUser = ({ isHeroSection }: any) => {
  const { dispatch } = useContext(SessionContext);
  const { dispatch: propertyInfoDispatch } = useContext(PropertyInfoContext);
  const { t } = useTranslation();
  const { setRoute } = useRouteHelper();

  const isLogged = useDetectIsLogged();
  const isAdmin = useDetectIsAdmin();
  const user = useGetUserDetails();

  const handleLogOut = () => {
    dispatch({ type: SessionReducerActionOptions.Reset, session: null });
    propertyInfoDispatch({ type: PropertyInfoReducerActionOptions.Update, propertyInfo: new PropertyInfoContextDto() });
  };
  return (
    <HStack flex="1" spacing="1">
      <Menu>
        <MenuButton
          as={Button}
          rightIcon={isLogged ? <HamburgerIcon /> : null}
          variant="outline"
          rounded="xl"
          px="2"
          py="1"
          alignItems="baseline"
          bg={!isHeroSection ? 'inherit' : 'white'}
        >
          <HStack>
            <Avatar
              bg={isLogged ? 'secondary.500' : 'transparent'}
              color={isLogged ? 'white' : 'inherit'}
              icon={<AiOutlineUser fontSize="2em" />}
              size="sm"
              _hover={{ cursor: 'pointer' }}
              name={isLogged ? user?.firstName : ''}
              src={isLogged ? user?.firstName : ''}
            />
            {!isLogged && <Text fontSize={'14px'}>{t('account.login')}</Text>}
          </HStack>
        </MenuButton>
        <MenuList>
          <MenuGroup title={t('account.profile')}>
            <RouterLink to={isLogged ? setRoute('dashboard.profile') : setRoute('account.login')}>
              <MenuItem>{isLogged ? t('account.myAccount') : t('account.login')}</MenuItem>
            </RouterLink>
            <RouterLink to={isLogged ? setRoute('becomeAHost.propertyInformation') : setRoute('account.register')}>
              <MenuItem>{isLogged ? t('account.list') : t('account.register')}</MenuItem>
            </RouterLink>
            {isLogged && (
              <RouterLink to={setRoute('search.property')}>
                <MenuItem> {t('header.searchBtn')}</MenuItem>
              </RouterLink>
            )}
            {isAdmin && (
              <RouterLink to={setRoute('adminArea')}>
                <MenuItem> {t('account.admin')}</MenuItem>
              </RouterLink>
            )}
          </MenuGroup>
          {!isLogged && <MenuDivider />}
          {!isLogged && (
            <MenuGroup>
              <RouterLink to={setRoute('search.property')}>
                <MenuItem> {t('header.searchBtn')}</MenuItem>
              </RouterLink>
              <RouterLink to={setRoute('becomeAHost.propertyInformation')}>
                <MenuItem> {t('header.listBtn')}</MenuItem>
              </RouterLink>
            </MenuGroup>
          )}
          {isLogged && (
            <>
              <MenuDivider />
              <MenuItem onClick={handleLogOut}>{t('account.logOut')}</MenuItem>
            </>
          )}
        </MenuList>
      </Menu>
    </HStack>
  );
};
